import { useApolloClient, useMutation } from '@apollo/react-hooks';
import {
  CREATE_ENTITY,
  UPDATE_ENTITY,
  UPSERT_ENTITY,
} from '../../graphql/entity/mutation';
import {
  CreateEntity,
  CreateEntityVariables,
} from '../../graphql/entity/types/CreateEntity';
import {
  UpdateEntity,
  UpdateEntityVariables,
} from '../../graphql/entity/types/UpdateEntity';
import {
  UpsertEntity,
  UpsertEntityVariables,
} from '../../graphql/entity/types/UpsertEntity';
import { GraphqlError } from '../../common/constants';
import { displaySnackBar } from '../../common/displaySnackbar';

export const useUpsertEntity = () => {
  const client = useApolloClient();
  return useMutation<UpsertEntity, UpsertEntityVariables>(UPSERT_ENTITY, {
    onError: (error) => {
      if (error.graphQLErrors.length) {
        if (error.graphQLErrors[0].extensions) {
          const code = error.graphQLErrors[0].extensions['original']['name'];
          if (code === GraphqlError.CRM_ID_EXIST) {
            displaySnackBar(client, {
              type: 'ERROR',
              message: 'idCRM existant',
              isOpen: true,
            });
          }
        }
      }
    },
  });
};

export const useCreateEntity = () => {
  const client = useApolloClient();
  return useMutation<CreateEntity, CreateEntityVariables>(CREATE_ENTITY, {
    onError: (error) => {
      if (error.graphQLErrors.length) {
        if (error.graphQLErrors[0].extensions) {
          const code = error.graphQLErrors[0].extensions['original']['name'];
          if (code === GraphqlError.CRM_ID_EXIST) {
            displaySnackBar(client, {
              type: 'ERROR',
              message: 'idCRM existant',
              isOpen: true,
            });
          }
        }
      }
    },
  });
};

export const useUpdateEntity = () => {
  return useMutation<UpdateEntity, UpdateEntityVariables>(UPDATE_ENTITY, {
    onError: (error) => console.log(error),
  });
};
